import { call, put, takeEvery } from "redux-saga/effects";

import * as apis from "../../../../network/apis/companyPortalEditRequests";
import * as actions from "./actions";
import * as types from "./types";
import { clearMyCompanyActiveEditRequest } from "../../MyCompany/actions";
import { showErrorMsg, showSuccessMsg } from "../../../../utils/Helpers";

const extractErrorMessage = (error) =>
  error?.response?.data?.message || error?.message || "";

function* createCompanyEditRequestSaga({ payload }) {
  const { data, onSuccess } = payload || {};
  try {
    const editRequest = yield call(apis.createCompanyEditRequest, data);
    yield put(actions.createCompanyEditRequestSuccess(editRequest));
    yield showSuccessMsg("addedSuccessfully");
    if (typeof onSuccess === "function") onSuccess(editRequest);
  } catch (error) {
    const message = extractErrorMessage(error);
    yield put(actions.createCompanyEditRequestFailure({ error: message }));
    if (message) yield showErrorMsg(message);
  }
}

function* getCompanyEditRequestSaga({ payload }) {
  const { id } = payload || {};
  try {
    const editRequest = yield call(apis.getCompanyEditRequest, id);
    yield put(actions.getCompanyEditRequestSuccess(editRequest));
  } catch (error) {
    const message = extractErrorMessage(error);
    yield put(actions.getCompanyEditRequestFailure({ error: message }));
    if (message) yield showErrorMsg(message);
  }
}

function* updateCompanyEditRequestSaga({ payload }) {
  const { id, data, onSuccess } = payload || {};
  try {
    const editRequest = yield call(apis.updateCompanyEditRequest, id, data);
    yield put(actions.updateCompanyEditRequestSuccess(editRequest));
    yield showSuccessMsg("updatedSuccessfully");
    if (typeof onSuccess === "function") onSuccess(editRequest);
  } catch (error) {
    const message = extractErrorMessage(error);
    yield put(actions.updateCompanyEditRequestFailure({ error: message }));
    if (message) yield showErrorMsg(message);
  }
}

function* deleteCompanyEditRequestSaga({ payload }) {
  const { id, onSuccess } = payload || {};
  try {
    yield call(apis.deleteCompanyEditRequest, id);
    yield put(actions.deleteCompanyEditRequestSuccess());
    // Clear nested id from cached `/my_company` immediately so Profile's
    // sync effect does not fire GET /company_edit_requests/:id (404 after delete).
    yield put(clearMyCompanyActiveEditRequest());
    yield showSuccessMsg("deletedSuccessfully");
    if (typeof onSuccess === "function") onSuccess();
  } catch (error) {
    const message = extractErrorMessage(error);
    yield put(actions.deleteCompanyEditRequestFailure({ error: message }));
    if (message) yield showErrorMsg(message);
  }
}

export default function* companyEditRequestSagas() {
  yield takeEvery(
    types.CREATE_COMPANY_EDIT_REQUEST_REQUEST,
    createCompanyEditRequestSaga,
  );
  yield takeEvery(
    types.GET_COMPANY_EDIT_REQUEST_REQUEST,
    getCompanyEditRequestSaga,
  );
  yield takeEvery(
    types.UPDATE_COMPANY_EDIT_REQUEST_REQUEST,
    updateCompanyEditRequestSaga,
  );
  yield takeEvery(
    types.DELETE_COMPANY_EDIT_REQUEST_REQUEST,
    deleteCompanyEditRequestSaga,
  );
}
